// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"c6a70d49","496":"fa1e7037","623":"bd01b03c","660":"d34d71f4","667":"77b2f4fa","680":"ff3ba0f7","748":"48da2502","825":"1ee7a32d"}[chunkId] + ".chunk.js";
};